var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TableUserContacts',{attrs:{"contactTypes":_vm.contactTypes,"isLoading":_vm.disabled || !_vm.usedSearch,"readonly":_vm.readonly},model:{value:(_vm.contacts),callback:function ($$v) {_vm.contacts=$$v},expression:"contacts"}})
}
var staticRenderFns = []

export { render, staticRenderFns }